import { mapActions, mapGetters } from 'vuex';
import IconProfile from '@/components/icons/IconProfile.vue';
import IconListSimple from '@/components/icons/IconListSimple.vue';
import IconListCheck from '@/components/icons/IconListCheck.vue';
import IconHeartSmall from '@/components/icons/IconHeartSmall.vue';
import IconLogout from '@/components/icons/IconLogout.vue';
import IconNavPromo from '@/components/icons/IconNavPromo.vue';

export default {
  name: 'DashboardNav',
  components: { IconNavPromo, IconLogout, IconHeartSmall, IconListCheck, IconListSimple, IconProfile },
  computed: {
    ...mapGetters({
      user: 'profile/user'
    }),
    isValentinesDayRange() {
      let now = new Date();
      let startDate = new Date(2026, 1, 9, 9, 0, 0);
      let endDate = new Date(2026, 1, 14, 23, 59, 59);
      return now >= startDate && now <= endDate;
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/LOGOUT'
    })
  }
};
